import type { EstateAsset } from "@/api/temp/TrustAIExecutiveService";
import { hasStrings, isCount, isList, isRecord, isString, isTimestamp } from "@/libs/agentSession";
import { asLifecycleScenario, type LifecycleScenario } from "./lifecycle";

export interface ExecutiveBoardSnapshot {
  assets: EstateAsset[];
  lastAnalyzedAt: string;
  lastEnforced: {
    controlId: string;
    scopeId: string;
    agentCount: number;
    agentIds: string[];
    includeFutureAgents: boolean;
  } | null;
  scenario: LifecycleScenario;
  discoveryStartedAt: string | null;
  evaluationStartedAt: string | null;
  completedEvaluations: number;
  autoChain: boolean;
}

export const isExecutiveBoardSnapshot = (value: unknown): value is ExecutiveBoardSnapshot =>
  isRecord(value) &&
  isList(value.assets, item =>
    isRecord(item) &&
    hasStrings(item, ["id", "name", "type", "owner", "businessUnit", "environment", "status", "platform", "description"]) &&
    isCount(item.violationCount) && typeof item.runtimeActive === "boolean",
  ) &&
  isTimestamp(value.lastAnalyzedAt) &&
  (value.lastEnforced === null || (
    isRecord(value.lastEnforced) &&
    hasStrings(value.lastEnforced, ["controlId", "scopeId"]) &&
    isCount(value.lastEnforced.agentCount) &&
    isList(value.lastEnforced.agentIds, isString) &&
    typeof value.lastEnforced.includeFutureAgents === "boolean"
  )) &&
  isString(value.scenario) && !!asLifecycleScenario(value.scenario) &&
  (value.discoveryStartedAt === null || isTimestamp(value.discoveryStartedAt)) &&
  (value.evaluationStartedAt === null || isTimestamp(value.evaluationStartedAt)) &&
  isCount(value.completedEvaluations) && typeof value.autoChain === "boolean";
